import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [personalData, setPersonalData] = useState(null);
  const [eventDetail, setEventDetail] = useState(null);

  return (
    <AppContext.Provider
      value={{
        personalData,
        setPersonalData,
        eventDetail,
        setEventDetail,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
